import { useCallback, useEffect, useMemo, useState } from 'react';
import { useServerStorage } from 'utils/useServerStorage';
import { languageCodesToSelectionListValue } from './utils';
const languageCodes = [
    'en',
    'de',
    'fr',
    'da',
    'fi',
    'no',
    'sv',
    'es',
    'pt',
    'pl',
    'el',
    'hu',
    'it',
    'cs',
    'ro',
    'sq',
    'hr',
    'tr',
    'lt',
    'bg',
    'nl',
    'uk',
    'ru',
];
const languages = languageCodesToSelectionListValue(languageCodes);
/** A hook for managing the state of a language selection list. */
export function useLanguageSelectionList(options) {
    var _a;
    // We need to memo the options because of interdependency on consumption.
    const memoOptions = useMemo(() => options, [options]);
    const { selectedLanguageCodes } = memoOptions;
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const { data = {}, set } = useServerStorage('user');
    const recentlyUsedLanguagesCodes = useMemo(() => { var _a, _b; return (_b = (_a = data.agent_copilot) === null || _a === void 0 ? void 0 : _a.recentlyUsedLanguageCodes) !== null && _b !== void 0 ? _b : []; }, [(_a = data.agent_copilot) === null || _a === void 0 ? void 0 : _a.recentlyUsedLanguageCodes]);
    useEffect(() => {
        setSelectedLanguages(languageCodesToSelectionListValue(selectedLanguageCodes !== null && selectedLanguageCodes !== void 0 ? selectedLanguageCodes : []));
    }, [selectedLanguageCodes]);
    const clearSelection = useCallback(() => {
        setSelectedLanguages([]);
    }, []);
    const onChange = useCallback(({ selectedValues, selectedItem }) => {
        setSelectedLanguages(selectedValues);
        set({
            agent_copilot: (draft) => {
                var _a;
                draft.recentlyUsedLanguageCodes = Array.from(new Set([
                    (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value.code) !== null && _a !== void 0 ? _a : null,
                    ...recentlyUsedLanguagesCodes,
                ])).slice(0, 5);
            },
        });
    }, [recentlyUsedLanguagesCodes, set]);
    return useMemo(() => ({
        languages,
        recentlyUsedLanguagesCodes,
        selectedLanguages,
        clearSelection,
        onChange,
    }), [clearSelection, onChange, recentlyUsedLanguagesCodes, selectedLanguages]);
}
